import { render, staticRenderFns } from "./RightSideLogin.vue?vue&type=template&id=47d3bd6a&scoped=true"
import script from "./RightSideLogin.vue?vue&type=script&lang=js"
export * from "./RightSideLogin.vue?vue&type=script&lang=js"
import style0 from "./RightSideLogin.vue?vue&type=style&index=0&id=47d3bd6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d3bd6a",
  null
  
)

export default component.exports